import { bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass } from "../../dbschema";
import { bl_fi_generic_doc_hdr_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class EinvoiceBatchPoolToIrbLinkIncludingGenDocHdrContainerModel extends BaseContainerModel {
    myEInvoiceBatchPoolToIrbLink : bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass = new bl_fi_my_einvoice_batch_pool_to_irb_link_RowClass();
    genericDocHdr : bl_fi_generic_doc_hdr_RowClass = new bl_fi_generic_doc_hdr_RowClass();
}